// Metadati stato → colore/icona/label, usati sia per i badge in tabella sia per la
// legenda della pagina "Personale Disponibile Live". Coerenti con i colori della
// pagina sorella Mezzi Disponibili Live (indisponibile = stesso rosso del fermo).
export const STATO_META = {
    disponibile:   { label: "Disponibile",   color: "#10B981", bg: "#D1FAE5", icon: "✓" },
    in_turno:      { label: "In turno",      color: "#D97706", bg: "#FEF3C7", icon: "⏱" },
    indisponibile: { label: "Indisponibile", color: "#DC2626", bg: "#FEE2E2", icon: "⚠" },
};
